export default __webpack_public_path__ + "e4b8ce297fc54c041572a2661a1f3979.svg";